<template>
  <MultiSelect
    v-model="selectedUsers"
    :options="resolvedUsers"
    option-label="label"
    filter
    :filter-fields="['name', 'email', 'label', 'searchText']"
    display="chip"
    :placeholder="placeholder || $t('UserMultiSelectInput.placeholder')"
    :invalid="invalid"
    :disabled="disabled || loading"
    :loading="loading"
    class="w-full"
    data-testid="user-multi-select-input"
  >
    <template #option="slotProps">
      <div
        class="flex flex-col py-0.5"
        :data-user-email="slotProps.option.email || undefined"
      >
        <span class="text-[var(--color-dark)]">{{ slotProps.option.name || slotProps.option.label }}</span>
        <span
          v-if="slotProps.option.email"
          class="text-xs text-[var(--color-disabled)]"
        >
          {{ slotProps.option.email }}
        </span>
      </div>
    </template>
    <template #emptyfilter>
      <span class="text-sm text-[var(--color-disabled)]">{{ $t('UserMultiSelectInput.empty') }}</span>
    </template>
    <template #empty>
      <span class="text-sm text-[var(--color-disabled)]">
        {{ loading ? $t('UserMultiSelectInput.loading') : $t('UserMultiSelectInput.empty') }}
      </span>
    </template>
  </MultiSelect>
</template>

<script>
import MultiSelect from 'primevue/multiselect';
import NetworkContent from '@/helpers/networking/NetworkContent';
import { normalizeParticipantUsers } from '@/utils/userParticipants';

export default {
  name: 'UserMultiSelectInput',
  components: {
    MultiSelect,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    users: {
      type: Array,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      localUsers: [],
      loading: false,
    };
  },
  computed: {
    resolvedUsers() {
      return this.users ?? this.localUsers;
    },
    selectedUsers: {
      get() {
        const ids = new Set((this.modelValue || []).map(String));
        return this.resolvedUsers.filter((user) => ids.has(String(user.id)));
      },
      set(users) {
        const ids = (users || []).map((user) => String(user.id)).filter(Boolean);
        this.$emit('update:modelValue', [...new Set(ids)]);
      },
    },
  },
  watch: {
    users: {
      immediate: true,
      handler(nextUsers) {
        if (nextUsers == null) {
          this.loadUsers();
        }
      },
    },
  },
  methods: {
    async loadUsers() {
      if (this.users != null || this.loading) return;
      this.loading = true;
      try {
        const { data } = await NetworkContent.getParticipants();
        this.localUsers = normalizeParticipantUsers(data?.users ?? []);
      } catch {
        this.localUsers = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
